import { render, staticRenderFns } from "./interest-delete.vue?vue&type=template&id=0aac4dc9&"
import script from "./interest-delete.vue?vue&type=script&lang=js&"
export * from "./interest-delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports